var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5003 3.5835C13.5842 3.5835 7.16699 10.7548 7.16699 18.8127C7.16699 26.8074 11.7417 35.4974 18.8792 38.8335C20.5431 39.6113 22.4575 39.6113 24.1214 38.8335C31.259 35.4974 35.8337 26.8074 35.8337 18.8127C35.8337 10.7548 29.4164 3.5835 21.5003 3.5835ZM21.5003 21.5002C23.4793 21.5002 25.0837 19.8958 25.0837 17.9168C25.0837 15.9378 23.4793 14.3335 21.5003 14.3335C19.5213 14.3335 17.917 15.9378 17.917 17.9168C17.917 19.8958 19.5213 21.5002 21.5003 21.5002Z",
    fill: "#41B64D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.419521412969d7ecd8103a975c84720e.svg";
export { ForwardRef as ReactComponent };